import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        personalInfo: {
            allFieldsRequired: string;
            graduationMonthPlaceholder: string;
            graduationYearPlaceholder: string;
        };
        pending: {
            redirectText: string;
        };
    };
    errorId: {
        graduationDateRequired: string;
        invalidGraduationDate: string;
    };
};


export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    countryPlaceholder: 'Select your Country',
    schoolNamePlaceholder: 'Enter your University',
    firstNamePlaceholder: 'Enter your first name',
    firstName: 'First Name',
    lastNamePlaceholder: 'Enter your last name',
    lastName: 'Last Name',
    schoolName: 'University',
    emailAddressPlaceholder: 'Enter your email address',
    emailAddress: 'Email Address',
    birthDate: 'Date of Birth',
    verifyMyStudentStatus: 'Verify and continue',
    infoShared1: 'Information entered into this web form will be used for verification purposes. ',
    infoShared2: 'The information will be shared with Lumion. ',
    getHelp: 'SheerID FAQs',
    poweredBy: 'Verification services powered by SheerID.',
    step: {
        personalInfo: {
            title: 'Get Lumion Student <br> in one easy step',
            subtitle: 'Simply finish the form below to confirm your student status.<br>After confirmation, you will automatically receive the free <br>Lumion Student license!',
            graduationMonthPlaceholder: 'Anticipated Graduation Month',
            graduationYearPlaceholder: 'Anticipated Graduation Year',
            allFieldsRequired: 'All fields are required.',
        },
        docUpload: {
            title: 'Upload Documentation',
            uploadInstructions: 'Upload your school-issued document that shows:',
        },
        pending: {
            titleReview: 'Submission Successful!',
            titleCountdown: 'Submission Successful!',
            redirectText: 'Finish',
        },
        success: {
            title: 'Success',
            emailNotification: 'Thank you for verifying your student status!',
            redirectButtonText: 'Finish',
        },
        sso: {
            cancel: 'Upload proof of enrollment',
        },
    },
    errorId: {
        graduationDateRequired: 'Graduation date is required',
        invalidGraduationDate: 'Invalid graduation date',
    },
};
